import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Donate from "@/pages/Donate";
import InKind from "@/pages/InKind";
import DropOff from "@/pages/DropOff";
import Event from "@/pages/Event";
import VeteranApplication from "@/pages/VeteranApplication";
import TrainerApplication from "@/pages/TrainerApplication";
import Volunteer from "@/pages/Volunteer";
import Sponsors from "@/pages/Sponsors";
import Artists from "@/pages/Artists";
import Contact from "@/pages/Contact";
import ContentPage from "@/pages/ContentPage";
import GoldenFounder from "@/pages/GoldenFounder";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";

const CONTENT_SLUGS = ["about", "mission", "service-dog-program", "trainer-program", "veterans", "financial-transparency", "privacy", "terms", "accessibility"];

const withLayout = (el) => <Layout>{el}</Layout>;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={withLayout(<Home />)} />
      <Route path="/donate" element={withLayout(<Donate />)} />
      <Route path="/wishlist" element={withLayout(<InKind />)} />
      <Route path="/drop-off" element={withLayout(<DropOff />)} />
      <Route path="/14ddv" element={withLayout(<Event />)} />
      <Route path="/veterans/apply" element={withLayout(<VeteranApplication />)} />
      <Route path="/trainer/apply" element={withLayout(<TrainerApplication />)} />
      <Route path="/volunteer" element={withLayout(<Volunteer />)} />
      <Route path="/sponsors" element={withLayout(<Sponsors />)} />
      <Route path="/artists" element={withLayout(<Artists />)} />
      <Route path="/contact" element={withLayout(<Contact />)} />
      <Route path="/golden-founder" element={withLayout(<GoldenFounder />)} />
      <Route path="/founder" element={withLayout(<GoldenFounder />)} />
      {CONTENT_SLUGS.map((s) => (
        <Route key={s} path={`/${s}`} element={withLayout(<ContentPage slug={s} />)} />
      ))}
      <Route path="/payment/success" element={withLayout(<PaymentSuccess />)} />
      <Route path="/payment/cancel" element={withLayout(<PaymentCancel />)} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="*" element={withLayout(<Home />)} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
